/*
 * Copyright (c) 2021 Well Solutions SRL. All Rights Reserved.
 * This software is the proprietary information of Well Solutions SRL.
 * Use is subject to license and non-disclosure terms
 */

import {InjectionToken} from "@angular/core";

export const LOGGED_IN_CONTEXT_SERVICE = new InjectionToken('LoggedInContext');
